import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Analytics from "@/components/Analytics";
import Home from "@/pages/Home";
import Analyze from "@/pages/Analyze";
import Compare from "@/pages/Compare";
import Rankings from "@/pages/Rankings";
import Dashboard from "@/pages/Dashboard";
import About from "@/pages/About";
import ApiPage from "@/pages/ApiPage";
import ChannelPage from "@/pages/ChannelPage";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import SiteMapPage from "@/pages/SiteMapPage";
import { BlogIndex, BlogCategory, BlogPost } from "@/pages/Blog";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Analytics />
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/analyze" element={<Analyze />} />
              <Route path="/channel/:slug" element={<ChannelPage />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/rankings" element={<Rankings />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/about" element={<About />} />
              <Route path="/api" element={<ApiPage />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/legal/:slug" element={<Legal />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/sitemap" element={<SiteMapPage />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/category/:slug" element={<BlogCategory />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
      </div>
    </HelmetProvider>
  );
}

export default App;
